(function () {
  var mobileQuery = window.matchMedia('(max-width: 768px)');
  var resizeTimer = null;

  function getMobileOpenTrigger(content) {
    return document.querySelector('[aria-controls="' + content.id + '"][data-xtheta-mobile-open-trigger]');
  }

  function setMobileOpenHeight(content, trigger, inner) {
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');

    content.classList.add('is-open');
    content.style.height = inner.offsetHeight + 'px';
    content.dataset.xthetaMobileInitialized = 'true';
  }

  function openMobileFooterBlocks(scope) {
    var root = scope || document;
    var contents = root.querySelectorAll('[data-xtheta-mobile-open-content]');

    contents.forEach(function (content) {
      var trigger = getMobileOpenTrigger(content);
      var inner = content.querySelector('.collapsible-content__inner');

      if (!trigger || !inner) {
        return;
      }

      if (!mobileQuery.matches) {
        content.style.height = '';
        return;
      }

      if (content.dataset.xthetaMobileInitialized === 'true' && !content.classList.contains('is-open')) {
        return;
      }

      setMobileOpenHeight(content, trigger, inner);
    });
  }

  function scheduleMobileFooterOpen(scope) {
    window.requestAnimationFrame(function () {
      openMobileFooterBlocks(scope || document);
    });
  }

  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      openMobileFooterBlocks(document);
    }, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleMobileFooterOpen(document);
  });

  window.addEventListener('load', function () {
    openMobileFooterBlocks(document);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      openMobileFooterBlocks(document);
    });
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', function () {
      openMobileFooterBlocks(document);
    });
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(function () {
      openMobileFooterBlocks(document);
    });
  }

  window.addEventListener('resize', handleResize);

  document.addEventListener('shopify:section:load', function (event) {
    scheduleMobileFooterOpen(event.target);
  });
})();
